var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.06,
    height: 68.147,
    viewBox: "0 0 78.06 68.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 78.06,
    height: 68.148,
    fill: "#ffbd00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10350",
    "data-name": "Group 10350",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10349",
    "data-name": "Group 10349",
    transform: "translate(-0.001 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27729",
    "data-name": "Path 27729",
    d: "M58.073,8.17h5.874A14.156,14.156,0,0,1,78.06,22.282V54.04A14.147,14.147,0,0,1,63.947,68.148H14.113A14.147,14.147,0,0,1,0,54.04V22.282A14.156,14.156,0,0,1,14.113,8.17h5.869a11.065,11.065,0,0,1,2.974-4.654A12.238,12.238,0,0,1,30.746,0H47.315A12.257,12.257,0,0,1,55.1,3.515,10.982,10.982,0,0,1,58.073,8.17M39.028,20.96A17.205,17.205,0,1,1,26.868,26a17.162,17.162,0,0,1,12.16-5.039m8.423,8.78a11.926,11.926,0,1,0,3.482,8.418,11.883,11.883,0,0,0-3.482-8.418m16.5-16.276H55.831a2.646,2.646,0,0,1-2.647-2.648,5.023,5.023,0,0,0-1.744-3.5,6.726,6.726,0,0,0-4.125-2.023H30.746a6.737,6.737,0,0,0-4.132,2.023,5.051,5.051,0,0,0-1.743,3.5,2.643,2.643,0,0,1-2.643,2.648H14.113a8.855,8.855,0,0,0-8.82,8.818V54.04a8.855,8.855,0,0,0,8.82,8.818H63.947a8.853,8.853,0,0,0,8.82-8.818V22.282a8.853,8.853,0,0,0-8.82-8.818",
    transform: "translate(0 0)",
    fill: "#ffbd00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon4);
export default __webpack_public_path__ + "static/media/social_icon4.f6cde9bdf65303a4bfb632dcdf6faa61.svg";
export { ForwardRef as ReactComponent };